import { IncludeType } from '../../../common/enums';
import { FamilyGroup } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

export const getAttributesByFamily = async (
  familyId: string,
  locale: string,
  includeType: IncludeType = IncludeType.Available
): Promise<FamilyGroup[]> => {
  const url = `/family/${familyId}/attributes?include=${encodeURIComponent(includeType)}&marketLocale=${locale}`;
  const response = await productCatalogueHttp.get<FamilyGroup[]>(url);
  return response.data;
};
